import http from '@core/fetch'

export default {
  canUpgrade: () => http('/p/wedding/index.php/Admin/APIMerchant/upgrade'),
  upgradeApi: body =>
    http.post('/p/wedding/index.php/Admin/APIMerchant/upgrade_apply', {
      body,
      autoShowError: true
    })
}
